"use client";

import TitleComp from "@/components/titleBox";
import {
  list01,
  list02,
  list03,
  imgList01,
  imgList02,
} from "@/constants/about";
import styles from "./index.module.scss";
import AboutLayout from "@/components/about";
import _ from "lodash";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

export default function AboutHonor() {
  return (
    <AboutLayout>
      <div className={styles.secondBox}>
        <div className="wrapper hCenter">
          <TitleComp {...list01} />
          <Swiper
            className={styles.swiperBox + " " + styles.swiperBox01}
            spaceBetween={20}
            autoplay={{
              delay: 6000,
            }}
            modules={[Pagination, Autoplay]}
            loop={true}
            pagination={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: "auto",
                slidesPerGroup: 4,
              },
            }}
          >
            {imgList01.map((pic: string, key: number) => {
              return (
                <SwiperSlide key={key}>
                  <img src={pic} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className={styles.contentBox01}>
          <div className="wrapper hCenter">
            <TitleComp {...list02} />
          </div>
          <Swiper
            className={styles.swiperBox + " " + styles.swiperBox02}
            watchSlidesProgress={true}
            slidesPerView={"auto"}
            centeredSlides={true}
            loop={true}
            navigation={true}
            autoplay={{
              delay: 6000,
            }}
            modules={[Autoplay, Navigation]}
            onProgress={function (swiper: any) {
              for (var i = 0; i < swiper.slides.length; i++) {
                var slide = swiper.slides[i];
                var slideProgress = swiper.slides[i].progress;
                var modify = 1;
                if (Math.abs(slideProgress) > 1) {
                  modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
                var translate = slideProgress * modify * 130 + "px";
                var scale = 1 - Math.abs(slideProgress) / 5;
                var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                slide.style.transform =
                  "translateX(" + translate + ") scale(" + scale + ")";
                slide.style.zIndex = zIndex;
                slide.style.opacity = 1;
                if (Math.abs(slideProgress) > 3) {
                  slide.style.opacity = 0;
                }
              }
            }}
            onSetTransition={function (swiper: any, transition: number) {
              for (var i = 0; i < swiper.slides.length; i++) {
                var slide = swiper.slides[i];
                slide.style.transitionDuration = transition + "ms";
              }
            }}
          >
            {imgList02.map((pic: string, key: number) => {
              return (
                <SwiperSlide key={key}>
                  <img src={pic} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className="wrapper hCenter">
          <TitleComp {...list03} />
        </div>
      </div>
    </AboutLayout>
  );
}
